
'use client';

import type { CSSProperties, ReactNode } from 'react';
import { useTpx } from '@/lib/hooks/useTpx';

function TpxProvider({ children }: { children: ReactNode }) {
  const tpx = useTpx();

  return (
    <div id='tpx' style={{ '--tpx': tpx } as CSSProperties}>
      {children}
    </div>
  );
}

export default TpxProvider;
